import {inject, } from '@angular/core';
import { HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';

import { InjectionToken } from '@angular/core';

export const API_TOKEN_VALUE = new InjectionToken<string>('Main token to the API');

export const ApiKeyInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const apiToken = inject(API_TOKEN_VALUE);
    
    if (!apiToken) {
        console.error('API token not provided');
    }

    const apiReq = req.clone({ headers: req.headers.append('Authorization', 'Bearer ' + apiToken)});

    return next(apiReq);
};

